import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';

import { API } from '../../../request/api';

const useCategoryBar = () => {
  const [activeCategory, setActiveCategory] = useState(null);
  const [categories, setCategories] = useState(null);
  const params = useParams();
  const location = useLocation();

  const Login = useSelector((store) => store.Login);

  useEffect(() => {
    const paramArray = [
      params.id || null,
      params.sub || null,
      params.c3 || null,
      params.c4 || null,
      params.c5 || null,
      params.c6 || null
    ].filter((catItem) => catItem !== null);

    let catId = null;
    // eslint-disable-next-line default-case
    switch (true) {
      case paramArray.length === null || paramArray.length < 2:
        catId = null;
        API.get
          .categories(Login.city_id)
          .then((response) => {
            setCategories(response.data);
            return response;
          })
          .catch((error) => {
            // eslint-disable-next-line no-console
            console.error('Error : ', error);
          });
        break;
      case paramArray.length === 2:
        catId = paramArray[paramArray.length - 1];
        API.get
          .categories(Login.city_id, catId)
          .then((response) => {
            setCategories(response.data);
            return response;
          })
          .catch((error) => {
            // eslint-disable-next-line no-console
            console.error('Error : ', error);
          });
        setActiveCategory(paramArray[paramArray.length - 1]);
        break;
      case paramArray.length > 2:
        catId = paramArray[paramArray.length - 1];
        API.get
          .categories(Login.city_id, catId)
          .then((response) => {
            setCategories(response.data);
            return response;
          })
          .catch((error) => {
            // eslint-disable-next-line no-console
            console.error('Error : ', error);
          });
        setActiveCategory(paramArray[paramArray.length - 1]);
        break;
    }
  }, [location.pathname]); // eslint-disable-line

  const newCarfillo = { ...JSON.parse(localStorage.getItem('carfillo')) };
  localStorage.setItem(
    'carfillo',
    JSON.stringify({
      ...newCarfillo,
      Activity: {
        activeCategory
      }
    })
  );

  return {
    categories,
    activeCategory,
    setActiveCategory
  };
};

export default useCategoryBar;
